<template>
  <div class="header-component">
    <img :src="logo" alt="">
  </div>
</template>

<script>

var Logo = require("../assets/Logo.png")

export default {
  name: 'HeaderComponent',
  components: {
  },
  data:function(){
    return {
      logo: Logo
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.header-component{
  width: 100%;
  height: 55px;
  background-color: var(--primary-color);
  margin:0;
  padding:0;
  margin-bottom:10px;
}

.header-component img{
  height: 55px;
}
</style>
